import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import svg from './Memories.svg'

const imageCss = css`
  height: 170px;
  width: 100%;
  margin: 16px 0 20px 0;
`

export default function NoMemories() {
  const [t] = useTranslation()
  return <img data-testid="no-memories-img" className={imageCss} src={svg} alt={t('info-cards.memories.header')} />
}
